import React, { FC, useState } from 'react';
import { Box, Text } from '@bechtel/gds';
// ToDo Need to move this to a common component.
import { CircleStyled } from './styled';
import { map } from 'lodash';
import { Trans } from '@lingui/macro';
import { RodRequestWeldProps } from './types';
import { SectionToggle } from '../section-toggle';

export const RodRequestWelds: FC<RodRequestWeldProps> = ({ welds }) => {
  const [isWeldListOpen, setIsWeldListOpen] = useState(true);

  return (
    <Box
      css={{
        width: '100%',
      }}
      flexDirection={{ sm: 'column' }}
      data-testid="rod-room-welds-container"
    >
      <SectionToggle
        toggle={() => setIsWeldListOpen(!isWeldListOpen)}
        heading={'Associated Welds'}
        isOpen={isWeldListOpen}
      />
      {isWeldListOpen &&
        welds?.length > 0 &&
        map(welds, (weld) => (
          <Box
            justifyContent={{ sm: 'space-between' }}
            alignItems={{ sm: 'center' }}
            pl={{ sm: '500' }}
            pr={{ sm: '300' }}
            py={{ sm: '450' }}
            css={{
              width: '100%',
              boxShadow: '0 -2px 6px 0 rgb(0 0 0 / 10%)',
              background: 'white',
            }}
            key={weld.id}
          >
            <Box flexDirection={{ sm: 'column' }}>
              <Box mb={{ sm: '400' }}>
                <Text size="300" color="grey.1000" weight="600" family="graphik" style={{ lineHeight: 1.2 }}>
                  {weld.tag}
                </Text>
              </Box>
              <Box alignItems={{ sm: 'center' }}>
                {weld?.pipeMaterial && (
                  <>
                    <Text size="300" color="grey.700">
                      {weld?.pipeMaterial}
                    </Text>
                    <CircleStyled />
                  </>
                )}
                {weld?.type?.name && (
                  <>
                    <Text size="300" color="grey.700">
                      {weld?.type?.name}
                    </Text>
                    <CircleStyled />
                  </>
                )}
                 {weld?.pipeDiameter && weld?.pipeDiameter > 0 && (               
                  <>
                    <Text size="300" color="grey.700">
                      {`${weld?.pipeDiameter}"`}&nbsp;
                      <Trans>Diameter</Trans>
                    </Text>
                  </>
                )}
              </Box>
            </Box>
          </Box>
        ))}
    </Box>
  );
};
